import { ItemType, Sex } from "../../../inventory/type";

export interface MassChangeRequest {
  id?: number;
  sku?: string;
  skuExactMatch?: boolean;
  search?: string;
  types?: ItemType[];
  vendorId?: number;
  style?: string;
  styleExactMatch?: boolean;
  categoryTitle?: string;
  subcategoryTitle?: string;
  subcategory2Title?: string;
  categoryId?: number[];
  subcategoryId?: number[]
  subcategory2Id?: number[]
  patternNumber?: string;
  patternNumberExactMatch?: boolean;
  showOnWeb?: boolean;
  inStock?: boolean;
  excludeIds?: string[];
  skip?: number;
  take?: number;
  excludedItemIds?: string[];
  saleStartDate?: string;
  saleEndDate?: string;
  archived?: boolean;
  nonPurchasable?: boolean;
  gender?: Sex;
}

export interface TableItem {
  id: number;
  key: string;
  sku: string;
  type: string;
  category: string;
  description: string;
  price: number;
  salePeriod: string;
  vendor: string;
  style: string;
  showOnWeb: boolean;
  enabled: boolean;
}

export interface EnabledFields {
  categoryId: boolean;
  subcategoryId: boolean;
  subcategory2Id: boolean;
  showOnWeb: boolean;
  nonPurchasable: boolean;
  nonPurchasablePriceEnabled: boolean;
  saleStartDate: boolean;
  saleEndDate: boolean;
}

export interface MassChangeFormProps {
  form: any;
  enabledFields: EnabledFields;
  setEnabledFields: (fields: EnabledFields) => void;
  categoryId: number | null;
  setCategoryId: (id: number | null) => void;
  subcategoryId: number | null;
  setSubcategoryId: (id: number | null) => void;
  subcategory2Id: number | null;
  setSubcategory2Id: (id: number | null) => void;
  categoryOptions: any[];
  subcategoryOptions: any[];
  subcategory2Options: any[];
  isFormValid: () => boolean;
  massChangeLoading: boolean;
  handleFormSubmit: (values: any) => void;
  refreshCategories: () => Promise<void>;
}

export interface TableColumnsProps {
  tableData: TableItem[];
  setTableData: React.Dispatch<React.SetStateAction<TableItem[]>>;
  excludedItemIds: number[];
  setExcludedItemIds: React.Dispatch<React.SetStateAction<number[]>>;
  includedItemIds: number[];
  setIncludedItemIds: React.Dispatch<React.SetStateAction<number[]>>;
  updateSelectionMode: UpdateSelectionMode;
}

export enum UpdateSelectionMode {
  Automatic = 'Automatic',
  Manual = 'Manual'
};

export interface SearchProps {
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
  onCompleteSearch: (request: MassChangeRequest | null | undefined, mode: UpdateSelectionMode) => void;
  loading: boolean;
  enabledFields: EnabledFields;
  form: any;
}

export interface CategoryQueriesProps {
  categoryId: number | null;
  subcategoryId: number | null;
}

export interface CategoryQueriesResult {
  categoryData: any;
  subcategoryData: any;
  subcategory2Data: any;
  categoryOptions: any[];
  subcategoryOptions: any[];
  subcategory2Options: any[];
  refreshAllCategories: () => Promise<void>;
}
